import { render, staticRenderFns } from "./StatementsStatusesActions.vue?vue&type=template&id=079247f7&scoped=true&"
import script from "./StatementsStatusesActions.vue?vue&type=script&lang=ts&"
export * from "./StatementsStatusesActions.vue?vue&type=script&lang=ts&"
import style0 from "./StatementsStatusesActions.vue?vue&type=style&index=0&id=079247f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079247f7",
  null
  
)

export default component.exports